import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
} from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";
import { TranslateService } from "@ngx-translate/core";
import { formatDate } from "@angular/common";
import * as moment from "moment";
import { AngularFireAnalytics } from "@angular/fire/analytics";
import { Subscription, timer } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Component({
  selector: "app-video-detail",
  templateUrl: "./video-detail.component.html",
  styleUrls: ["./video-detail.component.css"],
})
export class VideoDetailComponent implements OnInit {
  @ViewChild("vcontent", { static: true }) element: ElementRef;
  constructor(
    public service: BaseService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    public analytics: AngularFireAnalytics
  ) {}
  notShow = false;
  access = false;
  encodeUrl: any;
  isShow: boolean;
  redirectUrl: any;
  item: any;
  public_id: any;
  reletedShows: any = [];
  videoDetail: any = {};
  thumbnails: any;
  loading_player = false;
  appConstant: any;
  background;
  iPageTabID: any;
  output_url: any;
  isPlaying = false;
  navigationSubscription: any;
  isLogin: boolean;
  shimmerStatus = {
    relatedvideo: true,
    poster: true,
  };
  token: any;
  scrollPosition = false;
  userInfo: any = {};
  moreBrowserStatus: boolean;
  messageShow: boolean;
  autoplay = false;
  event: any;
  request_error: boolean;
  errorMessage: any;
  type: any;
  action: any;
  videoCount = 0;
  timerSubscription: Subscription;

  ngOnInit(): void {
    this.redirectUrl = this.router.url;
    this.appConstant = environment;
    this.event = window.history.state.event;
    this.navigationSubscription = this.route.params.subscribe((params) => {
      this.loading_player = false;
      this.public_id = params["public_id"];
      this.isPlaying = false;
      if (localStorage.getItem(environment.localStorageKey)) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);

      this.getVideoDetail();
    });
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
  }
  @HostListener("scroll", ["$event"])
  @ViewChild("scroll")
  private myScrollContainer: ElementRef;

  getVideoDetail() {
    this.service.videoDetailService(this.public_id).subscribe(
      (detail) => {
        if (detail) {
          this.videoDetail = detail.results;
          this.findDuplicates(this.videoDetail.cast_and_crew);
          this.token = this.videoDetail.access_video_token;
          this.checkVideoStatus();
          const index = detail.results.thumbnails
            .map((el) => {
              return el.image_type;
            })
            .indexOf("landscape");
          if (index !== -1) {
            this.thumbnails = detail.results.thumbnails[index]?.asset;
          } else {
            this.thumbnails = this.appConstant.landscapeDefault;
          }

          if (this.videoDetail.type !== "live") {
            const sendDtata = {
              token: this.token,
              web: "web",
              partner_id: this.videoDetail.posted_id,
              type: this.videoDetail.type,
            };
            if (
              (detail.results.is_login_required === "yes" && this.isLogin) ||
              detail.results.is_login_required === "no"
            ) {
              this.service.coockiesPolicyService(sendDtata).subscribe(
                (res) => {
                  if (this.videoDetail.view_duration > 0) {
                    this.autoplay = true;
                  } else {
                    this.autoplay = false;
                  }
                  this.route.queryParamMap.subscribe((params: any) => {
                    if (params.params.watching) {
                      this.autoplay = true;
                    }
                  });
                  this.output_url = res.url;
                  this.setVideoType();
                  this.loading_player = true;
                  this.shimmerStatus.poster = false;
                },
                (err) => {
                  if (err) {
                    this.access = true;
                    this.isPlaying = true;
                    this.shimmerStatus.poster = false;
                  }
                }
              );
            }
          } else {
            let currentTime = formatDate(
              new Date(),
              "hh:mm:ss a ",
              "en-US",
              "+0530"
            );
            let currentDuration = moment(currentTime, "HH:mm:ss: A").diff(
              moment().startOf("day"),
              "seconds"
            );
            let start_time = moment(
              this?.videoDetail?.channel_content?.start_time,
              "HH:mm:ss: "
            ).diff(moment().startOf("day"), "seconds");
            if (currentDuration >= start_time) {
              let activeDuration = start_time + this?.videoDetail?.duration;
              if (activeDuration > currentDuration) {
                this.videoDetail["showTimer"] = true;
                this.action = "done";
                this.autoplay = true;
              }
            }
            this.output_url = this.videoDetail.output_url;
            this.setVideoType();
            this.loading_player = true;
            this.shimmerStatus.poster = false;
          }

          this.service.relatedShowsService(this.public_id).subscribe(
            (res) => {
              if (res) {
                this.shimmerStatus.relatedvideo = false;
                this.reletedShows = res.results;
              }
            },
            (err) => {
              if (err) {
                this.shimmerStatus.relatedvideo = false;
              }
            }
          );
        }
      },
      (err) => {
        if (err.status === 0) {
          this.toastr.error("CONNECTION REFUSED", "OOPS!", {
            closeButton: true,
          });
        } else {
          this.toastr.error(err.message, "OOPS!"),
            {
              closeButton: true,
            };
        }

        this.router.navigate(["/home"]);
      }
    );
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    // this.timerSubscription.unsubscribe();
  }

  watchTrailer() {
    this.output_url = this.videoDetail.trailer;
  }
  customOptionsvideo: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    center: true,
    navText: [
      "<i class='mdi mdi-arrow-left'></i>",
      "<i class='mdi mdi-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 3.4,
      },
      380: {
        items: 3.8,
      },
      450: {
        items: 4,
      },
      650: {
        items: 5.1,
      },
      925: {
        items: 6,
      },
      1108: {
        items: 7,
      },
      1257: {
        items: 7.3,
      },
      1460: {
        items: 7.5,
      },
    },
    nav: true,
  };

  tradinglearn: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    center: false,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: [
      "<i class='mdi mdi-arrow-left'></i>",
      "<i class='mdi mdi-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 3.4,
      },
      380: {
        items: 3.8,
      },
      450: {
        items: 4,
      },
      650: {
        items: 5.1,
      },
      925: {
        items: 6,
      },
      1108: {
        items: 7,
      },
      1257: {
        items: 7.3,
      },
      1460: {
        items: 7.5,
      },
    },
    nav: true,
  };

  playVideo() {
    this.loading_player = true;
  }
  videoStatus(event) {
    console.log(event, "check event");
    // if (event.videoStatus == "ended") {
    //   this.changeVideo(this.reletedShows[0]);
    // }
    console.log(event);
    this.videoCount++;
    if (event.videoStatus == "error") {
      this.loading_player = false;
    }
    this.isPlaying = event.isPlaying;
    console.log(this.videoDetail?.duration, "cehk videodetail duration");
    console.log(event?.totalDuration, "total duration");
    console.log(event?.viewDuration, "view duration");
    console.log(event?.videoStatus, "video status");
    console.log(this.videoCount, "check video count");
    console.log(
      (event?.viewDuration / this.videoDetail?.duration) * 100,
      "check progress data========"
    );
    let newProgressData =
      (event?.viewDuration / this.videoDetail?.duration) * 100;
    console.log(newProgressData, "chewc new progress sssssss");
    console.log("video status", event?.videoStatus);
    if (event?.videoStatus !== "ended") {
      setInterval(function () {
        console.log("====");
      }, 1000);
      // setTimeout(myArray.myMethod, 1.0*1000);
    }
    if (newProgressData >= 10 && event?.videoStatus !== "ended") {
      console.log("10 work ");
      this.analytics.logEvent("video_playback 10", {
        video_event: "progress",
        user_id: this.service.encryptedData?.id,
        video_id: this.videoDetail?.public_id,
        video_title: this.videoDetail?.name,
        video_position: event?.viewDuration,
        video_duration: this.videoDetail?.duration,
        // video_progress:
        //   (event?.viewDuration / this.videoDetail?.duration) * 100,
        video_progress: 10.0,
        debug_mode: true,
      });
    }
    if (newProgressData >= 20 && event?.videoStatus !== "ended") {
      console.log("20 work");
      this.analytics.logEvent("video_playback", {
        video_event: "progress",
        user_id: this.service.encryptedData?.id,
        video_id: this.videoDetail?.public_id,
        video_title: this.videoDetail?.name,
        video_position: event?.viewDuration,
        video_duration: this.videoDetail?.duration,
        // video_progress:
        //   (event?.viewDuration / this.videoDetail?.duration) * 100,
        video_progress: 20.0,
        debug_mode: true,
      });
    }
    if (newProgressData >= 30 && event?.videoStatus !== "ended") {
      console.log("30 work");
      this.analytics.logEvent("video_playback", {
        video_event: "progress",
        user_id: this.service.encryptedData?.id,
        video_id: this.videoDetail?.public_id,
        video_title: this.videoDetail?.name,
        video_position: event?.viewDuration,
        video_duration: this.videoDetail?.duration,
        // video_progress:
        //   (event?.viewDuration / this.videoDetail?.duration) * 100,
        video_progress: 30.0,
        debug_mode: true,
      });
    }
    if (newProgressData >= 40 && event?.videoStatus !== "ended") {
      console.log("40 work");
      this.analytics.logEvent("video_playback", {
        video_event: "progress",
        user_id: this.service.encryptedData?.id,
        video_id: this.videoDetail?.public_id,
        video_title: this.videoDetail?.name,
        video_position: event?.viewDuration,
        video_duration: this.videoDetail?.duration,
        // video_progress:
        //   (event?.viewDuration / this.videoDetail?.duration) * 100,
        video_progress: 40.0,
        debug_mode: true,
      });
    }
    if (newProgressData <= 50 && event?.videoStatus !== "ended") {
      console.log("50 work");
      this.analytics.logEvent("video_playback", {
        video_event: "progress",
        user_id: this.service.encryptedData?.id,
        video_id: this.videoDetail?.public_id,
        video_title: this.videoDetail?.name,
        video_position: event?.viewDuration,
        video_duration: this.videoDetail?.duration,
        // video_progress:
        //   (event?.viewDuration / this.videoDetail?.duration) * 100,
        video_progress: 50.0,
        debug_mode: true,
      });
    }
    event?.videoStatus === "start" && this.videoCount === 1
      ? this.analytics.logEvent("video_playback", {
          video_event: "start",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: this.videoDetail?.duration,
          video_progress:
            (event?.viewDuration / this.videoDetail?.duration) * 100,
          debug_mode: true,
        })
      : event?.videoStatus === "ended"
      ? this.analytics.logEvent("video_playback", {
          video_event: "stop",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: event?.viewDuration,
          video_progress: this.videoDetail?.duration,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount === 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "pause",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress:
            (event?.viewDuration / this.videoDetail?.duration) * 100,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount > 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "resume",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress:
            (event?.viewDuration / this.videoDetail?.duration) * 100,
          debug_mode: true,
        })
      : "";
    // setInterval(()=> { this.myFunc() }, timeIntevalSeconds * 1000);
    if (event.message) {
      this.errorMessage = event.message;
    }
    // event?.videoStatus === 'pause' ? console.log('-----') : console.log('after code ')
  }
  progressLoadData(data: any): any {
    const newVideoDuration =
      (data?.viewDuration / this.videoDetail?.duration) * 100;
    console.log(newVideoDuration);
    if (newVideoDuration > 10) {
      this.timerSubscription = timer(0, 3000)
        .pipe(
          map(() => {
            // this.progressLoadData(); // load data contains the http request
          })
        )
        .subscribe();
    }
  }
  changeVideo(data: any) {
    if (data.source === "system" && data.type === "video") {
      this.router.navigate(["/video-detail", data.public_id]);
    } else if (data.source === "system" && data.type === "series") {
      this.router.navigate(["/series", data.public_id]);
    }
  }
  checkVideoStatus() {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.videoDetail.is_login_required === "yes") {
      if (encryptedData) {
        if (this.videoDetail.is_access === "free") {
          this.videoDetail.videoStatus = true;
        } else {
          if (this.videoDetail.is_user_content_purchase === "yes") {
            this.videoDetail.videoStatus = true;
          } else {
            this.videoDetail.bannerStatus = true;
            this.loading_player = true;
            this.notShow = true;
          }
        }
      } else {
        this.toastr.error("For this content you need to login first.", "OOPS!"),
          {
            closeButton: true,
          };
        setTimeout(() => {
          this.router.navigate(["/login"], {
            queryParams: { public_id: this.encodeUrl },
          });
        }, 2000);
      }
    } else {
      this.videoDetail.videoStatus = true;
    }
  }
  setVideoType() {
    let extension = this.output_url.split(".")[3];
    if (extension == "mp4") {
      this.type = "video/mp4";
    } else {
      this.type = "application/x-mpegURL";
    }
  }

  handleEvent(evt: any) {
    if (evt.action == "done") {
      this.action = evt.action;
      this.videoDetail["showTimer"] = true;
      this.loading_player = false;
      this.autoplay = true;
      this.getVideoDetail();
    }
  }
  findDuplicates(arr) {
    let castCrew = [];
    arr.forEach((element) => {
      // remove duplicate name
      let match = castCrew.find((r) => r.name == element.name);
      if (match) {
      } else {
        castCrew.push({ name: element.name, image: element.image, type: [] });
      }
    });
    castCrew.map((item) => {
      arr.map((e) => {
        if (e.name == item.name) {
          if (typeof e.type == "object") {
            //lets map if value is an object
            e.value.map((z) => {
              item.type.push(z);
            });
          } else {
            item.type.push(e.type);
          }
        }
      });
    });
    this.videoDetail.cast_and_crew = castCrew;
  }
}
